import { Hidden } from '@mui/material';
import Grid from 'components/core/Grid';
import styled from 'styled-components';

const LeftColumn = styled(Grid)`
  background: linear-gradient(180deg, #1c5699, #173456);
  display: flex;
  flex-direction: column;
  align-items: center;

  ${props => props.theme.breakpoints.down('lg')} {
    padding: ${props => props.theme.spacing(4)} !important;
  }

  ${props => props.theme.breakpoints.down('md')} {
    padding: ${props => props.theme.spacing(3)} !important;
  }
`;

const RightColumn = styled(Grid)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

interface Props {
  LeftColumnSlot: React.ReactNode;
  RightColumnSlot: React.ReactNode;
}

export const SplitPageLayout = ({ LeftColumnSlot, RightColumnSlot }: Props) => {
  return (
    <Grid container>
      <Hidden mdDown>
        <LeftColumn item xs={12} sm={5}>
          {LeftColumnSlot}
        </LeftColumn>
      </Hidden>
      <RightColumn item xs={12} md={7}>
        {RightColumnSlot}
      </RightColumn>
    </Grid>
  );
};
